"use strict";

var _defineProperty = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _shifts;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bn_js_1 = __importDefault(require("bn.js"));

var number_1 = require("./number");

var Units;

(function (Units) {
  Units["Wei"] = "Wei";
  Units["Gwei"] = "Gwei";
  Units["Eth"] = "Eth";
  Units["Ether"] = "Ether";
})(Units = exports.Units || (exports.Units = {}));

var shifts = (_shifts = {}, _defineProperty(_shifts, Units.Wei, 0), _defineProperty(_shifts, Units.Gwei, 9), _defineProperty(_shifts, Units.Eth, 18), _shifts);

function toWei(value) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Units.Eth;
  var result = null;

  if (unit === Units.Ether) {
    unit = Units.Eth;
  }

  var shift = shifts[unit];

  if (Number.isInteger(shift)) {
    var numberString = number_1.toNumberString(value, {
      shift: shift
    });
    result = new bn_js_1.default(numberString, 10);
  }

  return result;
}

exports.toWei = toWei;

function toEth(value) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Units.Wei;
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
  var result = null;

  if (unit === Units.Ether) {
    unit = Units.Eth;
  }

  var shift = shifts[unit];

  if (Number.isInteger(shift)) {
    shift = -(shifts[Units.Eth] - shift);
    result = number_1.toNumberString(value, {
      shift: shift,
      precision: precision
    });
  }

  return result;
}

exports.toEth = toEth;
exports.toEther = toEth;